import { useMemo } from "react";
import { SectionPage } from "@/components/section-page";
import { DataTable } from "@/composites/data-table/index";
import { useTableStyles } from "./table.styles";
import { LocalizationText, LocalizationDate } from "@/app/index";
import { usePageContextDelivery } from "../../context/delivery-context";
import { TrackingListItemType } from "@/schemas/index";
import { Text, Button } from "@/base/components/index";
import { Link } from "@/components/link";

export const ModuleTable = () => {
  const { styles } = useTableStyles();
  const { controllerDataTable, currentLang, fetchModalTrackingView } =
    usePageContextDelivery();

  const columns: any = useMemo(
    () => [
      {
        dataIndex: "ProductName",
        title: (
          <LocalizationText value="products.delivery.table.column.hardware" />
        ),
        minWidth: 200,
        render: (text: string, record: TrackingListItemType) => (
          <Text>{text || record.Name || record.Id}</Text>
        ),
      },
      {
        dataIndex: "BusinessUnitName",
        title: (
          <LocalizationText value="products.delivery.table.column.business.unit" />
        ),
        minWidth: 160,
        render: (text: string, record: TrackingListItemType) => {
          return record.BusinessUnitId && text ? (
            <Link
              to={`/${currentLang}/business-units/${record.BusinessUnitId}`}
              type="primary"
              strong
            >
              {text}
            </Link>
          ) : (
            <Text>{text}</Text>
          );
        },
      },
      {
        dataIndex: "DateSold",
        title: <LocalizationText value="products.delivery.table.column.sold" />,
        minWidth: 120,
        render: (text: string) =>
          text ? <LocalizationDate value={new Date(text)} /> : null,
      },
      {
        dataIndex: "Order",
        title: (
          <LocalizationText value="products.delivery.table.column.order" />
        ),
        minWidth: 120,
      },
      {
        dataIndex: "DeliveryStatus",
        title: (
          <LocalizationText value="products.delivery.table.column.delivery.status" />
        ),
        minWidth: 140,
      },
      {
        dataIndex: "TrackingNumber",
        title: (
          <LocalizationText value="products.delivery.table.column.tracking" />
        ),
        minWidth: 160,
        render: (text: string, record: TrackingListItemType) =>
          text ? (
            <Button
              type="link"
              onClick={() =>
                fetchModalTrackingView({
                  Id: record.Id,
                  TrackingNumber: text,
                  ProductId: record.ProductId,
                  ProductName: record.ProductName,
                  DeliveryStatus: record.DeliveryStatus,
                })
              }
            >
              {text}
            </Button>
          ) : null,
      },
    ],
    [currentLang],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <DataTable<TrackingListItemType>
        controller={controllerDataTable}
        columns={columns}
        searched={false}
      />
    </SectionPage>
  );
};
